import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import useAdminLocationAlerts from "../../../../../containers/FacilityDetailsPage/hooks/useAdminLocationAlerts";
import { LocationAlertData } from "../../../../../models/LocationAlert";
import ModalConfirm from "../../../../ModalConfirm";
import { AdminLocationAlertCreateModal } from "../../../AdminLocationAlertCreateModal";

import "./styles.scss";

export interface IAdminLocationAlertsListRowActionsProps {
  isHeader?: boolean;
  locationAlert?: LocationAlertData;
}

export const AdminLocationAlertsListRowActions: React.FC<
  IAdminLocationAlertsListRowActionsProps
> = ({ isHeader, locationAlert }) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params?: any) =>
    _t(`adminLocationAlertsPage.adminLocationAlertsList.${key}`, params);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const { remove, update } = useAdminLocationAlerts();

  const handleEdit = () => {
    setIsEditModalOpen(true);
  };

  const handleConfirmEdit = async (data: any) => {
    try {
      await update({ ...data, id: locationAlert?.id });
      toast.success(t("success"));
      setIsEditModalOpen(false);
    } catch (error) {
      // Do nothing, axios will handle the error
    }
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    const id = locationAlert?.id?.toString();
    if (!id) return;
    remove(id);
    setIsDeleteModalOpen(false);
  };

  if (isHeader) {
    return <div className="controls-column controls-header"></div>;
  }

  return (
    <>
      <div className="controls-column controls-item">
        <button className="btn btn-red" onClick={handleDelete}>
          {t("delete.button")}
        </button>
        <button className="btn btn-border" onClick={handleEdit}>
          {t("edit")}
        </button>
      </div>
      {isDeleteModalOpen && (
        <ModalConfirm
          translate={false}
          title={t("delete.title")}
          color="red"
          cancelLabel={t("delete.cancel")}
          confirmLabel={t("delete.confirm")}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={handleConfirmDelete}
        >
          <div>
            <span className="delete-modal-description">
              {t("delete.description")}
            </span>
            <div className="delete-modal-content">
              <div className="delete-modal-content-title">
                <span className="left">{t("delete.labels")}</span>
                <span>
                  {locationAlert?.labels?.map((label) => label.name).join(", ")}
                </span>
              </div>
              <div className="delete-modal-content-description">
                <span className="left">{t("delete.details")}</span>
                <span>
                  {t(`details.${locationAlert?.type}.text`, {
                    ...locationAlert?.details,
                  })}
                </span>
              </div>
            </div>
          </div>
        </ModalConfirm>
      )}
      {isEditModalOpen && (
        <AdminLocationAlertCreateModal
          onClose={() => setIsEditModalOpen(false)}
          submit={handleConfirmEdit}
          locationAlert={locationAlert}
        />
      )}
    </>
  );
};
